// Hook personalizzato per la vibrazione
const useHapticFeedback = () => {
  const triggerHapticFeedback = (pattern = 200) => {
    // Controlla se la Vibration API è supportata dal browser
    if ('vibrate' in navigator) {
      try {
        navigator.vibrate(pattern);
      } catch (error) {
        console.error("Haptic feedback failed:", error);
      }
    }
  };

  return triggerHapticFeedback;
};

export default useHapticFeedback;